// extracted by mini-css-extract-plugin
export default {"PrimaryCTA":"PrimaryCTA_PrimaryCTA__JdnVI"};